import { extendTheme } from '@chakra-ui/react';
import {
  BG_SECONDARY,
  BG_PRIMARY,
  TEXT_PRIMARY,
  TEXT_ALTERNATIVE,
  TEXT_SECONDARY,
} from '@/constants/colors';
import { FONT_FAMILY } from '@/constants/default-props';

/**
 * override chackra-ui for personalize purpose
 * see the docs: https://chakra-ui.com/guides/using-fonts
 */
const theme = {
  fonts: {
    heading: FONT_FAMILY.heading,
    subHeading: FONT_FAMILY.subHeading,
    body: FONT_FAMILY.body,

    // QR Purpose
    jost: `'Jost', sans-serif;`,
  },
  fontSizes: {
    heading: '36px',
    subHeading: '60px',
    body: '16px',
  },
  fontWeights: {
    heading: 400,
    subHeading: 400,
    body: 400,
  },
  styles: {
    global: {
      ':root': {
        '--fontItalic-heading': '',
        '--fontItalic-subHeading': '',
        '--fontItalic-body': '',
      },
    },
  },
  colors: {
    bgPrimary: 'rgba(42,72,46,1)',
    bgSecondary: 'rgba(186,163,100,1)',
    mainColorText: 'rgba(186,163,100,1)',
    secondaryColorText: 'rgba(42,72,46,1)',
    alternativeColorText: '#dca74f',

    transparent: 'transparent',
  },
};

export default extendTheme(theme);
